import {CITY_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {iterateObjectPropValues} from "../../other/iterateObjectPropValues";
import {FORTRESS_CAPTURE_WIN_POINTS, PALACE_CAPTURE_WIN_POINTS} from "../../../configs/winPoints";

export const calcCityWinPoints = (city) => {
  let cityWinPoints = 1; // за центральный квартал

  iterateObjectPropValues(CITY_TOKENS, (value) => {
    cityWinPoints += city[value]?.length || 0;
  });

  const palaces = city[SPECIAL_BUILDING_TOKENS.PALACE] || [];
  cityWinPoints += palaces.length * PALACE_CAPTURE_WIN_POINTS;

  const fortresses = city[SPECIAL_BUILDING_TOKENS.FORTRESS] || [];
  cityWinPoints += fortresses.length * FORTRESS_CAPTURE_WIN_POINTS;

  return cityWinPoints;
}